import styled from 'styled-components'

export const Currency = styled.span`
  font-size: 0.75em;
  color: var(--text-secondary);
`
